import axios from 'axios';
import Vue from 'vue';
import VueRouter from 'vue-router';
import store from '@/store';
import router from '@/routes';

//console.log('axios console', process.env, window.location.hostname);
// if (process.env == 'test') {
// 	axios.defaults.baseURL = process.env.VUE_APP_API_URL.replace('hair-', window.location.hostname + '-');
// 	console.log(axios.defaults.baseURL);
// } else {
// 	axios.defaults.baseURL = process.env.VUE_APP_API_URL;
// }

axios.defaults.baseURL = process.env.VUE_APP_API_URL;
axios.defaults.withCredentials = true;
axios.defaults.headers.common = {
	'Access-Control-Allow-Origin': '*',
	'Content-Type': 'application/json; charset = utf-8',
};
//axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';

// #3252 : 조회 전용 거부인지 판정한다. 세 조건이 모두 맞아야 한다.
// 하나라도 어긋나면 기존 403 처리를 그대로 따른다.
function isStateScopeDenied(response) {
	try {
		// vue-session 은 persist 옵션에 따라 localStorage 또는 sessionStorage 를 쓴다.
		// 어느 쪽인지 옵션을 따라가지 않고 둘 다 본다.
		const raw = window.localStorage.getItem('vue-session-key') || window.sessionStorage.getItem('vue-session-key') || '{}';
		const sessionUser = JSON.parse(raw).user;
		if (!sessionUser || sessionUser.company_id !== 'beautyplus') return false;
		const header = response.headers && response.headers['x-state-scope-denied'];
		const code = response.data && response.data.code;
		return header === 'STATE_SCOPE_FORBIDDEN' && code === 'STATE_SCOPE_FORBIDDEN';
	} catch (e) {
		return false;
	}
}

// #3406 : State 제한 사용자가 막힌 라우트를 부르면 서버가 body 없는 404 에 이 header 를 붙인다.
// 같은 이름의 header 를 mutation 403 도 쓰므로 값까지 맞아야 한다.
// #3406 추가형(2026-10-28) : 라우트 차단은 없어지고, 이 404 는 Restriction Only 보기의 요청 형태 거부에만 남는다.
// 4개 화면은 stateScopeOptional 로 받아 화면에서 체크를 풀고 안내하므로, 문구도 Restriction Only 보기 기준이다.
const STATE_SCOPE_BLOCKED = 'STATE_SCOPE_BLOCKED';
const STATE_SCOPE_MESSAGE = 'This request is not available in Restriction Only view.';
const STATE_SCOPE_NOTICE_MS = 3000;

// #3406 : 확정된 화면 이동마다 1 씩 오른다. 요청에 이 값을 찍어 두고 응답 때 값이 다르면
// 이미 떠난 화면(같은 주소로 다시 들어온 경우 포함)이 보낸 늦은 응답으로 보고 버린다.
let route_generation = 0;
router.afterEach(() => {
	route_generation += 1;
});

let state_scope_notice_at = 0;
// #3406 : 안내 화면 전환 잠금. 같은 화면에서 막힌 응답이 여러 개 와도 전환과 저장 확인창이 한 번만 일어나게 한다.
// 잠근 화면 진입의 세대를 함께 들고 있어서, 다른 화면에 들어간 뒤의 응답은 이 잠금에 걸리지 않는다.
let state_scope_redirect = null;

export function isStateScopeBlocked(error) {
	return !!(error && error.response && error.response.status === 404 && error.response.headers && error.response.headers['x-state-scope-denied'] === STATE_SCOPE_BLOCKED);
}

function notifyStateScopeBlocked() {
	const now = Date.now();
	if (now - state_scope_notice_at < STATE_SCOPE_NOTICE_MS) return;
	state_scope_notice_at = now;
	if (Vue.$toast) Vue.$toast.warning(STATE_SCOPE_MESSAGE);
}

function handleStateScopeBlocked(config) {
	const options = config || {};
	// 이전 화면 진입에서 보낸 요청이면 지금 화면과 무관하다. 안내도 띄우지 않는다.
	if (options.stateScopeGeneration !== route_generation) return;

	// 허용 화면이 일부 자료만 못 받는 경우다. 화면은 그대로 두고 호출한 쪽이 비운다.
	if (options.stateScopeOptional) {
		if (!options.stateScopeSilent) notifyStateScopeBlocked();
		return;
	}

	if (state_scope_redirect && state_scope_redirect.generation === route_generation) return;
	const lock = { generation: route_generation };
	state_scope_redirect = lock;
	const release = () => {
		if (state_scope_redirect === lock) state_scope_redirect = null;
	};

	// replace 로 막힌 화면을 이력에서 지운다. 뒤로 가기가 막힌 화면으로 돌아가 다시 막히지 않는다.
	router.replace({ name: 'accessError', params: { message: STATE_SCOPE_MESSAGE } }).then(release, err => {
		if (VueRouter.isNavigationFailure(err, VueRouter.NavigationFailureType.aborted)) {
			// 저장 확인창에서 사용자가 머물기로 했다. 화면은 남지만 막혔다는 사실은 알리고 잠시 다시 묻지 않는다.
			notifyStateScopeBlocked();
			setTimeout(release, STATE_SCOPE_NOTICE_MS);
			return;
		}
		if (!VueRouter.isNavigationFailure(err)) console.log(err);
		release();
	});
}

function setInterceptors(instance, show_loading_icon) {
	instance.interceptors.request.use(
		config => {
			//config.headers.Authorization = store.state.token;
			if (show_loading_icon) store.commit('setLoading', true);
			//config.headers.common['X-AUTH-TOKEN'] = store.state.token;
			// #3406 : 요청을 보낸 화면 진입을 기록한다. 아래 synchronous 옵션으로 호출하는 그 순간의 값이 찍힌다.
			config.stateScopeGeneration = route_generation;
			return config;
		},
		error => {
			//console.log('Axios request error', error);
			if (show_loading_icon) store.commit('setLoading', false);
			Promise.reject(error.response);
		},
		{ synchronous: true },
	);

	instance.interceptors.response.use(
		response => {
			if (show_loading_icon) store.commit('setLoading', false);
			return response;
			/*
			if (!response.headers.company_id) return response;

			console.log(response.headers.company_id, window.location.host.split('.')[0]);

			var url_host = window.location.host.split('.')[0];

			if (url_host == 'demo3') url_host = 'demo';

			if (url_host.startsWith('localhost') || response.headers.company_id == url_host) return response;

			window.location = '/login?sessionExpired=true&backUri=/'; */
		},
		error => {
			console.log(error);
			if (show_loading_icon) store.commit('setLoading', false);
			if (!error.response) {
				//console.log('Network Error');
				//this.$toast.success('Network Error');
				router.push({ name: 'error', params: { message: 'Network Error' } });
			} else {
				// #3406 : State 제한으로 막힌 조회는 범용 오류 화면 대신 제한 안내로 보낸다.
				if (isStateScopeBlocked(error)) {
					handleStateScopeBlocked(error.config);
					return Promise.reject(error);
				}
				// #3252 : State 조회 제한이 낸 거부는 세션 만료가 아니다. 다시 로그인시키면
				// 사용자가 영문도 모르고 로그인 화면으로 튕긴다. 회사·body code·header 가 모두
				// 정확히 맞을 때만 재로그인을 건너뛰고, 그 밖의 403 은 종전대로 세션 복구로 보낸다.
				if (error.response.status === 403 && isStateScopeDenied(error.response)) {
					return Promise.reject(error);
				}
				if (error.response.status === 403) {
					//if (store.getters['isLoggedIn']) alert('세션이 종료되어 다시 로그인합니다.');
					//store.commit('delToken');
					//router.push({ name: 'login', params: { sessionExpired: true } });
					//router.push({ name: 'login', params: { sessionExpired: true } });
					//router.push('/login');
					//alert(window.location.pathname);
					window.location = '/login?sessionExpired=true&backUri=' + window.location.pathname;
				} else {
					//console.log(error);
					router.push({ name: 'error', params: { message: error } });
				}
			}

			return Promise.reject(error);
		},
	);
	return instance;
}

const api = axios.create();
setInterceptors(api, true);

const session_api = axios.create();
setInterceptors(session_api, false);

// #3392 : 부가 출력(UPS 레이블의 홀박스 목록·레이블) 전용. 인터셉터를 붙이지 않아 실패해도 로딩 표시·오류 화면 이동이 없고,
// 호출한 쪽이 기존 UPS 출력으로 처리한다.
const quiet_api = axios.create();

export function apiHome() {
	return api.get('/api/home');
}

export function apiTest() {
	return api.get('/api/test');
}

// export function apiUps(param) {
// 	return api.post('/api/ups', param);
// }

export function apiSessionCheck() {
	return session_api.get('/api/global_session_check');
}

export function apiSystemMessage() {
	return session_api.get('/api/system_message');
}

export function apiInsertGoogleApiLog(param) {
	return session_api.post('/api/report/insertGoogleApiLog', param);
}

export { api, quiet_api };
